import { render, staticRenderFns } from "./RoleStatusCard.vue?vue&type=template&id=5dbc9406"
import script from "./RoleStatusCard.vue?vue&type=script&lang=js"
export * from "./RoleStatusCard.vue?vue&type=script&lang=js"
import style0 from "./RoleStatusCard.vue?vue&type=style&index=0&id=5dbc9406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports